import { render } from "./topBarStaging.vue?vue&type=template&id=5784212c&scoped=true"
import script from "./topBarStaging.vue?vue&type=script&lang=js"
export * from "./topBarStaging.vue?vue&type=script&lang=js"

import "./topBarStaging.vue?vue&type=style&index=0&id=5784212c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5784212c"]])

export default __exports__